import { LoadingSpinner } from '@teamleader/ahoy';
import React, { PureComponent } from 'react';

import * as styles from './styles.css';

class LoadingIndicator extends PureComponent {
  render() {
    return (
      <div className={styles.container}>
        <LoadingSpinner />
      </div>
    );
  }
}

export default LoadingIndicator;
